import React from 'react';
import { Tabs, Tab, Container, Row, Col } from 'react-bootstrap';
import $ from 'jquery';
import FullCrawl from './FullCrawl';
import ExtractedDataViewer from './ExtractedDataViewer';
import LogViewer from './LogViewer';
import ExtractionSelector from './ExtractionSelector';
import ExtractionSettings from './ExtractionSettings';
import JobDefinitionSelector from './JobDefinitionSelector';
import JobDefinitionSettings from './JobDefinitionSettings';
import JobDefinitionScriptEditor from './JobDefinitionScriptEditor';
import JobLauncher from './JobLauncher';
import ProjectSelector from './ProjectSelector';
import WaitAnimation from './WaitAnimation';
import { JobDefinitionService } from '../services/JobDefinitionService';
import { ScriptSchema } from '../services/JobDefinitionService';
import { ExtractionService } from '../services/ExtractionService';
import { ProjectService } from '../services/ProjectService';
import { UserService } from '../services/UserService';
import { StateManagementService } from '../services/StateManagementService';
import { LogService } from '../services/LogService';
import { DataService } from '../services/DataService';
import { ScriptGenerationService } from '../services/ScriptGenerationService';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';

const EXTRACTION_SETTINGS_TAB_KEY = 1;
const EXTRACT_DATA_TAB_KEY = 2;
const FULL_CRAWL_PROGRESS_TAB_KEY = 3;
const LOGS_TAB_KEY = 4;
const JOB_DEFINITION_TAB_KEY = 5;
const JOB_SCRIPT_TAB_KEY = 6;
const JOB_LAUNCHER_TAB_KEY = 7;
// const queryString = (querystrings, key) => {
//   let query = querystrings.substring(1);
//   let vars = query.split('&');
//   for (let i = 0; i < vars.length; i++) {
//     var pair = vars[i].split('=');
//     if (decodeURIComponent(pair[0]) === key) {
//       return decodeURIComponent(pair[1]);
//     }
//   }
// };

class MainInterface extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mainTabKey: EXTRACTION_SETTINGS_TAB_KEY,
            projects: [],
            projectId: null,
            extractions: [],
            currentExtractionId: null,
            batchId: null,
            activeFullCrawlBatchId: null,
            currentJobDefinitionId: null,
            currentGeneratedScriptId: null,
            generationTimer: null,
            timer: null,
            logs: [],
            activeJobId: null,
            crawling: false,
            crawlingCount: 0,
            generating: false,
            generationCount: 0,
            fullCrawlActive: false,
            runUrl: null,
            extractionSettingsEnabled: false,
            jobDefinitionEnabled: false,
            jobScriptEnabled: false,
            runConfigurationEnabled: false,
            logsEnabled: false,
            extractionDataEnabled: false,
            fullCrawlEnabled: false
        };
        // Load services and bind them to this component so they can access the state
        this.jobDefinitionService = new JobDefinitionService(this);
        this.extractionService = new ExtractionService(this);
        this.projectService = new ProjectService(this);
        this.userService = new UserService(this);
        this.stateManagementService = new StateManagementService(this);
        this.logService = new LogService(this);
        this.dataService = new DataService(this);
        this.scriptGenerationService = new ScriptGenerationService(this);
        // bind methods so they can access the state
        this.onJobDefinitionChange = this.onJobDefinitionChange.bind(this);
        this.logout = this.logout.bind(this);
        this.clearJobOutputTimer = this.clearJobOutputTimer.bind(this);
        this.handleMainTabSelect = this.handleMainTabSelect.bind(this);
        // this.handleSecondaryTabSelect = this.handleSecondaryTabSelect.bind(this);
        this.startFullCrawl = this.startFullCrawl.bind(this);
        this.stopFullCrawl = this.stopFullCrawl.bind(this);
        this.setFullCrawlActiveState = this.setFullCrawlActiveState.bind(this);
        this.hideModals = this.hideModals.bind(this);
        this.loadExtractions = this.loadExtractions.bind(this);
        this.onJobDefinitionCreated = this.onJobDefinitionCreated.bind(this);
        this.updateJobDefinition = this.updateJobDefinition.bind(this);
        this.onExtractionDelete = this.onExtractionDelete.bind(this);
        this.saveAndRunJob = this.saveAndRunJob.bind(this);
        this.saveAndRunDryJob = this.saveAndRunDryJob.bind(this);
        this.fetchMarkup = this.fetchMarkup.bind(this);
        this.handlePublishJobSuccess = this.handlePublishJobSuccess.bind(this);
        this.onProjectChange = this.onProjectChange.bind(this);
        this.generateScript = this.generateScript.bind(this);
        this.handleCrawlerResponse = this.handleCrawlerResponse.bind(this);
        this.getFullCrawlStats = this.getFullCrawlStats.bind(this);
        this.saveFetchedMarkupDetails = this.saveFetchedMarkupDetails.bind(this);

        this.fullCrawlStatusTimer = setInterval(
            () => {
                this.getFullCrawlStats()
            },
            1000
        );
    }
    getFullCrawlStats() {
        if (this.state.fullCrawlActive == true && this.currentExtraction?.id != null && this.state.activeFullCrawlBatchId != null) {
            var url = "/api/v1/extractions/" + this.currentExtraction.id + "/batches/" + this.state.activeFullCrawlBatchId + "/job_batch_stats"
            $.get(url, res => {
                this.setState({ jobStats: res });
            });
        }
    }
    hideModals() {
        this.extractionSelector?.createExtractionControl?.hideHandler();
    }
    logout() {
        localStorage.removeItem("id_token");
        localStorage.removeItem("access_token");
        localStorage.removeItem("profile");
        window.location.reload();
    }
    
    // componentDidMount() {
    //     const qsExtractionFilter = queryString(window.location.search, 'extraction');
    //     this.setState({extractionFilter: qsExtractionFilter || ''});
    // }
    componentWillUnmount() {
        this.clearJobOutputTimer();
    }
    clearJobOutputTimer() {
        if (this.timer != null) {
            clearInterval(this.timer)
            this.timer = null;
        }
    }
    // handleExtractionCreation(success) {
    //     if (success) {
    //         this.props.displayFeedback("Extraction Created Successfully", "success");
    //         // Reload extractions to include the new one
    //         this.loadExtractions(this.state.projectId);
    //     } else {
    //         this.props.displayFeedback("Failed to create extraction", "failure");
    //     }
    // }
    onJobDefinitionChange(selectedJob) {
        if (selectedJob == null) {
            this.setState({
                currentJobDefinitionId: null,
                currentGeneratedScriptId: null,
            });
        } else {
            this.jobDefinitionService.loadJobDefinition(selectedJob.extraction_id, selectedJob.id)
            .then(result => {
                let parsedJobDefinition = null;
                try {
                    parsedJobDefinition = {
                        ...result.jobDefinition,
                        script_generation_requests: result.jobDefinition.script_generation_requests.map(sgr => ({
                            ...sgr,
                            schema: ScriptSchema.fromJsonString(sgr.schema)
                        }))
                    }
                } catch (error) {
                    console.error('Failed to parse script generation request schema:', error);
                    this.props.displayFeedback("Failed to parse script generation request schema", "failure");
                    return;
                }
                this.stateManagementService.updateJobDefinition(parsedJobDefinition)
                .then(() => {
                    let mostRecentGeneratedScriptId = null;
                    if (result.jobDefinition.script_generation_requests && result.jobDefinition.script_generation_requests.length > 0) {
                        mostRecentGeneratedScriptId = result.jobDefinition.script_generation_requests[result.jobDefinition.script_generation_requests.length - 1].id;
                    }
                    this.setState({
                        currentJobDefinitionId: result.jobDefinition.id,
                        jobDefinitionEnabled: true,
                        jobScriptEnabled: true,
                        runConfigurationEnabled: true,
                        mainTabKey: JOB_DEFINITION_TAB_KEY,
                        currentGeneratedScriptId: mostRecentGeneratedScriptId,
                    });
                })
                .catch(error => {
                    console.error('Failed to update job definition state:', error);
                });
            })
            .catch(error => {
                console.error('Failed to load job definition:', error);
            });
        }
    }
    isJobStartUrlValid() {
        if (this.jobDefinitionSettings.doesJobHaveAtLeastOneValidStartUrl() && this.state.jobReferenceValid) {
            return true;
        }
        return false;
    }
    handleMainTabSelect(key) {
        this.setState({
            mainTabKey: key,
        });
        // Bug in the ace editor causes it to not re-render on state change, if
        // it's in a hidden tab. This should trigger it to re-render on tab change
        switch (parseInt(key)) {
            case JOB_SCRIPT_TAB_KEY:
                this.jobScriptEditor.refreshAceEditor();
                break;
            case JOB_LAUNCHER_TAB_KEY:
                this.jobLauncher.refreshAceEditor();
                break;
            case FULL_CRAWL_PROGRESS_TAB_KEY:
                //whenever the run configuration tab is clicked, check the state of any full crawls for this extraction
                if (this.currentExtraction) {
                    this.setFullCrawlActiveState(this.currentExtraction.id);
                }
                break;
        }
    }
    // handleSecondaryTabSelect(key) {
    //     this.setState({
    //         runJobTabKey: key
    //     });
    //     // Bug in the ace editor causes it to not re-render on state change, if
    //     // it's in a hidden tab. This should trigger it to re-render on tab change
    //     if (key == 1) {
    //         this.aceDebugger.editor.resize();
    //         this.aceDebugger.editor.renderer.updateFull();
    //     }
    // }
    handleSysAdminTabSelect(key) {
        this.setState({
            sysAdminTabKey: key
        });
        // Bug in the ace editor causes it to not re-render on state change, if
        // it's in a hidden tab. This should trigger it to re-render on tab change
        if (key == 1) {
            this.aceDebugger.editor.resize();
            this.aceDebugger.editor.renderer.updateFull();
        }
    }

    startFullCrawl() {
        let extractionId = this.currentExtraction?.id
        if (extractionId == null) {
            return;
        }
        let url = "/api/v1/extractions/" + extractionId + "/crawl/start";
        $.get(url, extractionBatch => {
            if (extractionBatch != null) {
                this.handlePublishJobSuccess(extractionBatch);
                return;
            }
            this.props.displayFeedback("Full Crawl Failed to Start", "failure");
        });
    }
    stopFullCrawl() {
        let extractionId = this.currentExtraction?.id
        if (extractionId == null) {
            return;
        }
        let url = "/api/v1/extractions/" + extractionId + "/crawl/stop";
        $.get(url, res => {
            if (res != null) {
                if (res.cancelled_at.Valid) {
                    this.props.displayFeedback("Full Crawl Stopped Successfully", "success");
                }
                this.setState({
                    fullCrawlActive: !res.cancelled_at.Valid,
                    activeFullCrawlBatchId: null
                });
            } else {
                this.props.displayFeedback("Full Crawl Failed to Stop", "failure");
            }
        });
    }
    setFullCrawlActiveState(extraction_id) {
        if (this.state.projectId == null || extraction_id == null) { 
            return;
        }
        $.get("/api/v1/extractions/" + extraction_id + "/crawl/is_active", res => {
            this.setState({
                fullCrawlActive: (res != null && res.active),
                activeFullCrawlBatchId: res.active ? res.batch_id : null
            });
        });
    }
    onExtractionChange(extractionItem) {
        var showAceEditorMargin = false
        if (!extractionItem) {
            this.setState({
                currentExtractionId: null,
                currentJobDefinitionId: null,
                currentGeneratedScriptId: null,
                extractionSettingsEnabled: false,
                batchId: null,
                activeFullCrawlBatchId: null,
                // sbJobTitle: this.state.jobTitleDefault,
                logs: [],
                jobDefinitionEnabled: false,
                jobScriptEnabled: false,
                runConfigurationEnabled: false,
                logsEnabled: false,
                extractionDataEnabled: false,
                fullCrawlEnabled: false,
                mainTabKey: null,
            });
        } else {
            const differentExtraction = this.state.currentExtractionId != extractionItem.id;
            if (!differentExtraction) {
                return;
            }
            this.extractionService.getExtraction(extractionItem.id)
            .then(result => {
                this.stateManagementService.updateExtraction(result)
                .then(() => {
                    this.setState({
                        currentExtractionId: extractionItem.id,
                        currentJobDefinitionId: differentExtraction ? null : this.state.currentJobDefinitionId,
                        currentGeneratedScriptId: differentExtraction ? null : this.state.currentGeneratedScriptId,
                        sbExtractionTitle: result.name,
                        // sbJobTitle: this.state.jobTitleDefault,
                        extractionSettingsEnabled: true,
                        jobDefinitionEnabled: false,
                        jobScriptEnabled: false,
                        runConfigurationEnabled: false,
                        logsEnabled: true,
                        extractionDataEnabled: true,
                        fullCrawlEnabled: true,
                        mainTabKey: EXTRACTION_SETTINGS_TAB_KEY
                    });
                })
                .catch(error => {
                    console.error('Failed to update extraction state:', error);
                });
                showAceEditorMargin = true
                this.setFullCrawlActiveState(result.id);
            })
            .catch(error => {
                console.error('Failed to get extraction:', error);
            });
        }
        this.jobDefinitionSelector.selectItem(null);
        if (this.aceEditor && this.aceEditor.editor) {
            this.aceEditor.editor.setOption("showPrintMargin", showAceEditorMargin); 
        }
    }
    onProjectChange(projectId) {
        this.setState({projectId: projectId}, () => {
            this.loadExtractions();
            this.extractionSelector.createExtractionControl.fetchUsers(projectId);
            this.extractionSelector.selectItem(null);
        });
    }
    loadExtractions() {
        const projectId = this.state.projectId;
        this.extractionService.loadExtractions(projectId)
        .then(result => {
            this.setState({
                extractions: result
            });
        })
        .catch(error => {
            console.error('Failed loading extractions:', error);
        });
    }
    onExtractionCreated(extractionItem) {
        this.stateManagementService.addExtraction(extractionItem)
        .then(() => {
            this.extractionSelector.selectItem(extractionItem);
        })
        .catch(error => {
            console.error('Failed to add extraction:', error);
        });
    }
    onJobDefinitionCreated(jobDefinition) {
        this.stateManagementService.addJobDefinition(jobDefinition)
        .then(() => {
            this.jobDefinitionSelector.selectItem(jobDefinition);
        })
        .catch(error => {
            console.error('Failed to add job definition:', error);
        });
    }
    updateJobDefinition(callback=null) {
        this.props.displayFeedback("Attempting to Update The Job Definition", "success");
        if (this.currentJobDefinition != null) {
            // if this is a root job make sure it has at least one valid start url
            if (!this.currentJobDefinition.root_job || this.currentJobDefinition.job_urls.length > 0) {
                this.jobDefinitionService.updateJobDefinition(this.currentJobDefinition)
                .then(result => {
                    const { jobDefinition, status, errorMessage } = result;
                    if(errorMessage){
                        this.props.displayFeedback("Error updating job definition: " + errorMessage, "failure");
                    } else if (status == "updated") {
                        // this.stateManagementService.updateJobDefinition(jobDefinition)
                        // .then(() => {
                            // update the extraction as it's partial crawl check may have changed
                            this.extractionService.updateExtraction(this.currentExtraction)
                            .then(() => {
                                // update all the other job definitions for this extraction, since the sample percentage may have changed
                                this.jobDefinitionService.updateAllJobDefinitionsForExtraction(this.state.currentExtractionId, this.state.currentJobDefinitionId)
                                .then(() => {
                                    if (callback) {
                                        callback();
                                    } else {
                                        this.props.displayFeedback("Job Definition Updated Successfully", "success");
                                    }
                                })
                                .catch(error => {
                                    console.error('Failed to update job definition:', error);
                                });
                            })
                            .catch(error => {
                                console.error('Failed to update extraction:', error);
                            });
                        // })
                        // .catch(error => {
                        //     console.error('Failed to update job definition:', error);
                        // });
                    }
                })
                .catch(error => {
                    this.props.displayFeedback("Failed to update job definition", "failure");
                    console.error('Failed loading projects:', error);
                });
            } else {
                this.props.displayFeedback("Please make sure the job definition has at least one valid start URL", "failure");
            }
        } else {
            this.props.displayFeedback("Invalid job definition", "failure");
        }
    }
    onJobDefinitionDelete(extraction_id, job_definition_id) {
        this.jobDefinitionService.deleteJobDefinition(extraction_id, job_definition_id)
        .then(result => {
            this.stateManagementService.deleteJobDefinition(extraction_id, job_definition_id)
            .then(() => {
                this.setState({
                    jobDefinitionEnabled: false,
                    jobScriptEnabled: false,
                    runConfigurationEnabled: false,
                    mainTabKey: EXTRACTION_SETTINGS_TAB_KEY,
                });
                this.jobDefinitionSelector.selectItem(null);
                this.props.displayFeedback("Job Definition Deleted Successfully", "success");
            })
            .catch(error => {
                console.error('Failed to delete job definition:', error);
                this.props.displayFeedback("Failed to delete job definition", "failure");
            });
        })
        .catch(error => {
            console.error('Failed to delete job definition:', error);
            this.props.displayFeedback("Failed to delete job definition", "failure");
        });
    }
    onExtractionDelete(extraction_id) {
        this.extractionService.deleteExtraction(extraction_id)
        .then(() => {
            this.stateManagementService.deleteExtraction(extraction_id)
            .then(() => {
                this.extractionSelector.selectItem(null);
                this.props.displayFeedback("Extraction Deleted Successfully", "success");
            })
            .catch(error => {
                console.error('Failed to delete extraction:', error);
                this.props.displayFeedback("Failed to delete extraction", "failure");
            });
        })
        .catch(error => {
            console.error('Failed to delete extraction:', error);
            this.props.displayFeedback("Failed to delete extraction", "failure");
        });
    }
    handlePublishJobSuccess(publishedBatch, extractionId=this.state.currentExtractionId) {
        if (publishedBatch == null) {
            this.props.displayFeedback("Failed to publish job", "failure");
            return
        }
        if (!publishedBatch.debug) {
            // add the batch to the extractions batches
            this.stateManagementService.updateExtraction({
                ...this.currentExtraction,
                // sort the batches so that the debug batch is always first, then the rest are sorted by id descending
                extraction_batches: this.currentExtraction.extraction_batches.concat(publishedBatch).sort((a,b) => b.debug ? 100000000 : b.id - a.id)
            }).then(() => {
                this.setState({
                    fullCrawlActive: !publishedBatch.cancelled_at.Valid,
                    activeFullCrawlBatchId: publishedBatch.id
                }, () => {
                    this.props.displayFeedback("Crawl Started Successfully, Batch ID: " + publishedBatch.id, "success");
                });
            });
            return
        }
        this.clearJobOutputTimer();
        this.setState({
            activeJobId: publishedBatch.job_id,
            crawling: true,
            crawlingCount: 0,
            batchId: publishedBatch.id,
        }, () => {
            this.props.displayFeedback("Job Published Successfully", "success");
            this.timer = setInterval(() => {
                this.setState({
                    crawlingCount: this.state.crawlingCount + 1
                });
                this.jobDefinitionService.getCrawlerOutput(extractionId, publishedBatch.id, publishedBatch.job_id) 
                .then(res => {
                    this.handleCrawlerResponse(res);
                }).catch(error => {
                    console.error('Failed to get crawler output:', error);
                    });
                }, 1000);
        });
    }
    handleCrawlerResponse(res) {
        if (res != null) {
            this.clearJobOutputTimer();
            this.setState({
                crawling: false,
                crawlingCount: 0
            });
            // if the job was a html minimizer request from the script generator, and the actual minimizer job isn't being run,
            // then store the minimized HTML in the state
            if (res.pureOutput.is_minimizer_job && this.state.currentJobDefinitionId != JobDefinitionService.MINIMIZER_JOB_DEFINITION_ID){
                if (res.pureOutput["response_code"] == 200) {
                    this.saveFetchedMarkupDetails(this.currentGeneratedScript, res.pureOutput)
                } else {
                    this.props.displayFeedback("Failed to fetch minimized HTML, please try again", "failure");
                }
            } else {
                // Otherwise, set the job output to the pure output
                this.stateManagementService.updateJobDefinition({
                    ...this.currentJobDefinition,
                    last_test_output: res.processedOutput
                }).then(() => { 
                    // Update the job definition to store the output
                    this.updateJobDefinition()
                }).catch(error => {
                    console.error('Failed to update job definition:', error);
                });
            }
        }
    }
    saveFetchedMarkupDetails(scriptGenerationRequest, minimizedHtmlLogRecord) {
        const sgrUpdate = {
            ...scriptGenerationRequest,
            minimized_html_file_location: minimizedHtmlLogRecord["file_path"],
            minimized_html_record_id: minimizedHtmlLogRecord["id"],
            minimized_html_record_batch_id: minimizedHtmlLogRecord["batch_id"],
            status: "markup retrieved"
        }
        // update the SGR in the database
        this.scriptGenerationService.updateScriptGenerationRequest(sgrUpdate).then((scriptRecord) => {
            // update the state
            this.stateManagementService.updateScriptGenerationRequest(this.currentJobDefinition, sgrUpdate).then(() => { 
                this.setState({
                    currentGeneratedScriptId: scriptRecord.request_id
                }, () => {
                    // The state update might have populated the schmema ace editors, there's a bug
                    // in the ace editor that causes it to not re-render on state change, if
                    // it's in a hidden tab. This should trigger it to re-render on tab change
                    if (this.jobScriptEditor) {
                        this.jobScriptEditor.refreshAceEditor();
                    }
                });
            }).catch(error => {
                console.error('Failed to record generation markup:', error);
            });
        }).catch(error => {
            console.error('Failed to record generation markup:', error);
        });
    }
    saveAndRunDryJob() {
        this.saveAndRunJob(true)
    }
    saveAndRunJob(debug=false) {
        this.props.displayFeedback("Saving and Running The Job", "success");
        const job_configuration = {
            start_url: this.currentJobDefinition.last_test_url,
            site_id: this.currentJobDefinition.last_test_site_id || 0,
            input: this.currentJobDefinition.last_test_input,
            data: this.currentJobDefinition.last_test_data,
            debug: debug
        }
        this.stateManagementService.updateJobDefinition({
            ...this.currentJobDefinition,
            last_test_url: this.currentJobDefinition.last_test_url,
            last_test_site_id: this.currentJobDefinition.last_test_site_id
        }).then(() => {
            this.updateJobDefinition(() => {
                this.jobDefinitionService.publishJob(this.state.currentExtractionId, 
                    this.state.currentJobDefinitionId, job_configuration)
                .then(publishedBatch => this.handlePublishJobSuccess(publishedBatch))
                .catch(error => {
                    console.error('Failed to publish job:', error);
                });
            });
        }).catch(error => {
            console.error('Failed to update job definition:', error);
        });
    }

    fetchMarkup(currentGeneratedScript) {
        const job_configuration = {
            start_url: currentGeneratedScript.minimized_html_url,
            site_id: currentGeneratedScript.minimized_html_site_id || 0,
            input: "{}",
            debug: true
        }
        this.jobDefinitionService.publishJob(ExtractionService.SYSTEM_EXTRACTION_ID, 
            JobDefinitionService.MINIMIZER_JOB_DEFINITION_ID, job_configuration)
        .then(publishedBatch => {
            const currentGeneratedScript = {
                ...this.currentGeneratedScript,
                minimized_html_site_id: publishedBatch.site_id,
                status: "markup requested"
            }
            // after fetch markup job is published, create a new SGR to hold the markup details
            this.scriptGenerationService.createInitialGenerationRequest(currentGeneratedScript).then((generateScriptResponse) => {
                const sgrUpdate = {
                    ...currentGeneratedScript,
                    id: generateScriptResponse.request_id,
                }
                const jobDefinitionUpdate = {
                    ...this.currentJobDefinition,
                    script_generation_requests: !this.currentJobDefinition.script_generation_requests ? [sgrUpdate] : [...this.currentJobDefinition.script_generation_requests, sgrUpdate]
                }
                this.stateManagementService.updateJobDefinition(jobDefinitionUpdate).then(() => { 
                    this.setState({
                        currentGeneratedScriptId: generateScriptResponse.request_id
                    }, () => {
                    // The state update might have populated the schmema ace editors, there's a bug
                    // in the ace editor that causes it to not re-render on state change, if
                    // it's in a hidden tab. This should trigger it to re-render on tab change
                    if (this.jobScriptEditor) {
                        this.jobScriptEditor.refreshAceEditor();
                        }
                        this.handlePublishJobSuccess(publishedBatch)
                    });
                }).catch(error => {
                    console.error('Failed to update script generation request:', error);
                });
            }).catch(error => {
                console.error('Failed to create initial generation request:', error);
            });
        }).catch(error => {
            console.error('Failed to publish job:', error);
        });
    }
    clearGenerationTimer() {
        if (this.generationTimer != null) {
            clearInterval(this.generationTimer)
            this.generationTimer = null;
        }
    }
    generateScript() {
        this.scriptGenerationService.startScriptGeneration(this.currentGeneratedScript).then(response => {
            this.props.displayFeedback("Script Generation Started Successfully", "success");
            this.clearJobOutputTimer();
            this.setState({
                generating: true,
                generationCount: 0
            });
            this.generationTimer = setInterval(() => {
                this.setState({
                    generationCount: this.state.generationCount + 1
                });
                this.scriptGenerationService.getGenerationResponse(response.request_id) 
                .then(generateScriptResponse => {
                    if (generateScriptResponse != null) {
                        if (generateScriptResponse.status == "completed" || generateScriptResponse.status == "failed") {
                            this.clearGenerationTimer();
                            this.setState({
                                generating: false,
                                generationCount: 0,
                            });
                            if (generateScriptResponse.status == "failed") {
                                this.props.displayFeedback("Script Generation Failed: " + generateScriptResponse.error, "failure");
                            } else {
                                const sgr = {
                                    ...this.currentGeneratedScript,
                                    response: generateScriptResponse.script
                                }
                                this.stateManagementService.updateScriptGenerationRequest(sgr)                            
                            }
                        }
                    }
                }).catch(error => {
                    console.error('Failed to get generation response:', error);
                });
            }, 1000);
        }, error => {
            this.props.displayFeedback("Failed to generate script", "failure");
            console.error('Failed generating script:', error);
        });
    }
    render() {
        this.currentExtraction = this.state.extractions?.find(e => e.id == this.state.currentExtractionId);
        this.currentJobDefinition = this.currentExtraction?.job_definitions?.find(jd => jd.id == this.state.currentJobDefinitionId);
        this.currentGeneratedScript = this.currentJobDefinition?.script_generation_requests?.find(sgr => sgr.id == this.state.currentGeneratedScriptId);
        return (
            <Container>
                <Row>
                    <Col md={12} className={ "text-end" }>
                        <a onClick={this.logout} className="btn btn-link" style={{ textAlign: 'right' }}>
                            Log out
                        </a>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <ProjectSelector 
                            ref={instance => { this.projectSelector = instance; }} 
                            onProjectChange={(project_id) => this.onProjectChange(project_id)} 
                            projectId={this.state.projectId}
                            projects={this.state.projects}
                            projectService={this.projectService}
                            stateManagementService={this.stateManagementService}
                        />
                    </Col>
                    <Col md={6}>
                        <ExtractionSelector 
                            ref={instance => { this.extractionSelector = instance; }} 
                            onExtractionChange={(extractionItem) => this.onExtractionChange(extractionItem)} 
                            extractions={this.state.extractions}
                            projectId={this.state.projectId}
                            extractionService={this.extractionService}
                            onExtractionCreated={(extractionItem) => this.onExtractionCreated(extractionItem)}
                        />
                    </Col>
                    <Col md={3} className={ "align-self-start text-center"  }> 
                        <JobDefinitionSelector 
                            ref={instance => { this.jobDefinitionSelector = instance; }} 
                            onJobDefinitionChange={(jobDefinition) => this.onJobDefinitionChange(jobDefinition)} 
                            currentExtraction={this.currentExtraction}
                            jobDefinitionService={this.jobDefinitionService}
                            onJobDefinitionCreated={(jobDefinition) => this.onJobDefinitionCreated(jobDefinition)}
                        />
                    </Col>
                </Row>
                <Row className="position-relative">
                    <div className="d-flex align-items-center justify-content-end position-absolute" style={{ top: '2.3rem', right: '0rem', zIndex: 1000, maxWidth: '100%', maxHeight: '100%' }}>
                        <WaitAnimation 
                            waiting={this.state.crawling}
                            waitCount={this.state.crawlingCount}
                            animationMessage="Waiting for crawler:"
                        />
                        <WaitAnimation 
                            waiting={this.state.generating}
                            waitCount={this.state.generationCount}
                            animationMessage="Generating script:"
                        />
                    </div>
                </Row>
                <Row>
                    {this.state.extractionSettingsEnabled && (
                        <Tabs
                            activeKey={this.state.mainTabKey != null ? this.state.mainTabKey : -1}
                            transition={false}
                            onSelect={this.handleMainTabSelect}
                            id="main-tabs"
                            className={ "my-3" }
                        >
                            <Tab disabled={ !this.state.extractionSettingsEnabled } eventKey={EXTRACTION_SETTINGS_TAB_KEY} title="Extraction Settings"> 
                                <ExtractionSettings 
                                    ref={instance => { this.extractionSettings = instance; }} 
                                    currentExtraction={this.currentExtraction}
                                    onExtractionDelete={(extraction_id) => this.onExtractionDelete(extraction_id)}
                                />
                            </Tab>
                            <Tab disabled={ !this.state.extractionDataEnabled } eventKey={EXTRACT_DATA_TAB_KEY} title="Extracted Data">
                                <ExtractedDataViewer
                                    ref={instance => { this.extractedDataViewer = instance; }}
                                    batches={ this.currentExtraction?.extraction_batches }
                                    currentExtraction={this.currentExtraction}
                                    batchId={this.state.batchId}
                                    dataService={this.dataService}
                                    stateManagementService={this.stateManagementService}
                                    extractedData={this.state.extractedData}
                                />
                            </Tab>
                            <Tab disabled={ !this.state.fullCrawlEnabled } eventKey={FULL_CRAWL_PROGRESS_TAB_KEY} title="Full Crawl">       
                                <FullCrawl
                                    ref={instance => { this.fullCrawl = instance; }}
                                    startFullCrawl={this.startFullCrawl}
                                    stopFullCrawl={this.stopFullCrawl}
                                    currentExtraction={this.currentExtraction}
                                    fullCrawlActive={this.state.fullCrawlActive} 
                                    jobStats={this.state.jobStats}
                                />
                            </Tab>
                            <Tab disabled={ !this.state.logsEnabled } eventKey={LOGS_TAB_KEY} title="Logs">
                                <LogViewer ref={instance => { this.logViewer = instance; }} 
                                    batches={ this.currentExtraction?.extraction_batches }
                                    currentExtraction={this.currentExtraction}
                                    batchId={this.state.batchId}  
                                    logs={this.state.logs}
                                    logService={this.logService}
                                    stateManagementService={this.stateManagementService}
                                />
                            </Tab>
                            <Tab disabled={ !this.state.jobDefinitionEnabled } eventKey={JOB_DEFINITION_TAB_KEY} title="Job Definition"> 
                                <JobDefinitionSettings 
                                    ref={instance => { this.jobDefinitionSettings = instance; }} 
                                    currentExtraction={this.currentExtraction}
                                    currentJobDefinition={this.currentJobDefinition}
                                    projectId={this.state.projectId}
                                    jobDefinitionService={this.jobDefinitionService}
                                    stateManagementService={this.stateManagementService}
                                    onJobDefinitionUpdate={this.updateJobDefinition}
                                    onJobDefinitionDelete={(extraction_id, job_definition_id) => this.onJobDefinitionDelete(extraction_id, job_definition_id)}
                                />
                            </Tab>
                            <Tab disabled={ !this.state.jobScriptEnabled } eventKey={JOB_SCRIPT_TAB_KEY} title="Job Script">
                                <JobDefinitionScriptEditor 
                                    ref={instance => { this.jobScriptEditor = instance; }} 
                                    currentExtraction={this.currentExtraction}
                                    currentJobDefinition={this.currentJobDefinition}
                                    onJobDefinitionUpdate={this.updateJobDefinition}
                                    stateManagementService={this.stateManagementService}
                                    onJobDefinitionScriptUpdate={() => this.updateJobDefinition()}
                                    fetchMarkup={(currentGeneratedScript) => this.fetchMarkup(currentGeneratedScript)}
                                    minimizedHtmlRecordId={this.state.minimizedHtmlRecordId}
                                    scriptEditorSchema={this.state.scriptEditorSchema}
                                    generateScript={() => this.generateScript()}
                                    currentGeneratedScript={this.currentGeneratedScript}
                                />
                            </Tab>
                            <Tab disabled={ !this.state.runConfigurationEnabled } eventKey={JOB_LAUNCHER_TAB_KEY} title="Run Job">
                                <JobLauncher 
                                    ref={instance => { this.jobLauncher = instance; }} 
                                    currentExtraction={this.currentExtraction}
                                    currentJobDefinition={this.currentJobDefinition}
                                    saveAndRunJob={this.saveAndRunJob}
                                    saveAndRunDryJob={this.saveAndRunDryJob}
                                    activeJobId={this.state.activeJobId}
                                    batchId={this.state.batchId}
                                    crawling={this.state.crawling}
                                    displayFeedback={(message, type) => this.props.displayFeedback(message, type)}
                                    stateManagementService={this.stateManagementService}
                                />
                            </Tab>
                        </Tabs>
                    )}
                </Row>
            </Container>
        );
    }
}

export default MainInterface;
